import React, { useEffect, useState } from 'react';
import './CuponesModal.css';
import Modal from 'react-modal';
import { toast } from 'react-toastify';
import cuponImage from '../../images/descuento.webp';

export default function CuponesModal({ openModal, setOpenModal, cuponesProps = [], setCuponAplicado }) {
    const cuponAplicado = localStorage.getItem('cupon') || '';
    const cupones = cuponesProps.map(item => (item.codigo));
    const [cupon, setCupon] = useState('');
    const handleSaveCupon = () => {
        if (cupones.includes(cupon.toUpperCase())) {
            localStorage.setItem('cupon', cupon.toUpperCase());
            setCuponAplicado(cupon.toUpperCase())
            setOpenModal(false);
            toast.success('Cupón aplicado', { autoClose: 1000 });
        }
        else {
            toast.error('Cupón no válido', { autoClose: 1000 });
        }
    }

    return (
        <>
            <Modal
                isOpen={openModal}
                onRequestClose={() => setOpenModal(false)}
                className="cuponesModal"
                overlayClassName={'overlayCuponesModal'}
            >
                <div className='cuponesContainer'>
                    <div className='headerCupones'>
                        <img src={cuponImage} alt="cuponImage" style={{ width: "100px", height: "100px" }} />
                        <button onClick={() => setOpenModal(false)}>X</button>
                    </div>
                    <div className='bodyCupones'>
                        <form onSubmit={(e) => { e.preventDefault(); handleSaveCupon(); }}>
                            <br />
                            <h4>Aplicar cupón:</h4>
                            <input type='text' value={cupon} onChange={(e) => setCupon(e.target.value)} required maxLength={20} />
                            <button type='submit'>Aplicar</button>
                        </form>
                    </div>
                </div>
            </Modal>
        </>
    );
}
